import { Modal, Col, Row } from "antd";
import React from "react";
import { Form } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";

import { ContentLoader, FormField, FormFieldType } from "@components";
import { COUNTRY_FLAGS } from "@config";
import { AppConfigActions, selectCountryRiskUpdating } from "@redux";
import { i18, trb } from "@utilities";

export const EditCountry = ({ onClose, countryConfig }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectCountryRiskUpdating);

  const onSubmit = async data => {
    try {
      await dispatch(AppConfigActions.updateCountryRisk(data));
      onClose();
    } catch {}
  };

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={countryConfig}
      render={({ handleSubmit }) => {
        return (
          <Modal
            visible
            width={800}
            onOk={handleSubmit}
            onCancel={onClose}
            cancelText={trb(i18.Buttons.Cancel)}
            okText={trb(i18.Buttons.Ok)}
            okButtonProps={{ loading: isLoading }}
            cancelButtonProps={{ disabled: isLoading }}
          >
            <form className="my-4" onSubmit={handleSubmit}>
              {isLoading && <ContentLoader />}
              {!isLoading && (
                <>
                  <Row gutter={[16, 0]}>
                    <Col sm={12} xs={24}>
                      <FormField
                        name="iso2"
                        disabled
                        component={FormFieldType.input}
                        title={trb(i18.ApplicationsLabels.iso2FilterInput)}
                        size="large"
                        className="mb-4"
                      />
                    </Col>
                    <Col sm={12} xs={24}>
                      <FormField
                        name="iso3"
                        component={FormFieldType.input}
                        title={trb(i18.ApplicationsLabels.iso3Label)}
                        size="large"
                        className="mb-4"
                      />
                    </Col>
                  </Row>

                  <Row gutter={[16, 0]}>
                    <Col sm={12} xs={24}>
                      <FormField
                        name="title"
                        component={FormFieldType.input}
                        title={trb(i18.ApplicationsLabels.countryTitleLabel)}
                        size="large"
                        className="mb-4"
                      />
                    </Col>
                    <Col sm={12} xs={24}>
                      <FormField
                        name="rating"
                        component={FormFieldType.select}
                        title={trb(i18.ApplicationsLabels.countryRatingLabel)}
                        optionsLabel="label"
                        optionsValue="value"
                        options={[1, 2, 3, 4].map(item => ({ value: item, label: item }))}
                        size="large"
                        className="mb-4"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={24}>
                      <FormField
                        name="isActual"
                        component={FormFieldType.checkbox}
                        label={trb(i18.ApplicationsLabels.isActualFilterInput)}
                        inline={true}
                        size="large"
                        className="mb-4"
                      />
                    </Col>
                  </Row>
                  <p className="my-4">{trb(i18.ApplicationsLabels.countryFlagsLabel)}</p>
                  <Row gutter={[16, 0]}>
                    {Object.values(COUNTRY_FLAGS).map((flag, index) => (
                      <Col xs={24} sm={12} md={8} key={flag}>
                        <FormField
                          name={`countryFlagsLists.${index}.isActive`}
                          component={FormFieldType.checkbox}
                          label={trb(i18.CountryFlags[flag])}
                          inline={true}
                          size="large"
                          className="mb-4 mr-3"
                        />
                      </Col>
                    ))}
                  </Row>
                </>
              )}
            </form>
          </Modal>
        );
      }}
    />
  );
};
